import { MobileFiltersDrawer } from "features/filters/components";

import type { SelectedFacetParam } from "common/types";

import { LIST_LEADS_FILTERS } from "../../../../constants";
import useListLeadsParams from "../../../../hooks/useListLeadsParams";
import FilterOptions from "./FilterOptions";

import type { ListLeadsFacets, ListLeadsSearchParams } from "../../../../types";

interface MobileFiltersProps {
  searchParams: ListLeadsSearchParams<SelectedFacetParam>;
  setSearchParams: (
    searchParams: ListLeadsSearchParams<SelectedFacetParam>,
  ) => void;
  facets: ListLeadsFacets;
  isLoadingFacets: boolean;
}

export default function MobileFilters({
  searchParams,
  setSearchParams,
  facets,
  isLoadingFacets,
}: MobileFiltersProps) {
  const { resetSearchParam, resetFilters } = useListLeadsParams(
    searchParams,
    setSearchParams,
  );

  return (
    <MobileFiltersDrawer
      title="Filter leads"
      filters={LIST_LEADS_FILTERS}
      onClear={(type) => {
        if (type === "all") {
          resetFilters();
        } else {
          resetSearchParam(type);
        }
      }}
      getSelectionCount={(filterKey) => searchParams[filterKey].length}
      renderFilter={(filterKey) => (
        <FilterOptions
          filterKey={filterKey}
          searchParams={searchParams}
          setSearchParams={setSearchParams}
          facets={facets}
          isLoadingFacets={isLoadingFacets}
        />
      )}
    />
  );
}
